export const projectsData = [
  {
    id: 1,
    title: "CollegeBook",
    description: "Developed a marketplace iOS application for trading textbooks targeting college students. \
      Designed the database schema for posts, users, messaging with efficient static storage management. \
      Implemented real time chatting, cross platform authentication with Google, and notifications by using cloud functions. \
      Incorporated ISBN scanner, Algolia as the search engine, and Firebase analytics to track user behavior. \
      Managed backend in Node.js, loaded Firebase Functions and Cloud Messaging for notifications.",
    category: "iOS",
    year: 2019,
    image: "https://is2-ssl.mzstatic.com/image/thumb/Purple123/v4/a0/38/58/a0385871-14fc-e58b-d91e-611521700094/AppIcon-4-0-0-1x_U007emarketing-0-0-0-5-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/1024x1024.jpg",
    github: "https://github.com/jinkim22/CollegeBook",
    demo: "https://docs.google.com/presentation/d/1KbcMGsfX5UhJTRVQkjMDI8NyVgHKCafd8Qd4EhLQSzs/edit?usp=sharing"
  },
  {
    id: 2,
    title: "Algorithmic Trading Bot",
    description:
      "Algorithmic Trading Bot",
    category: "Python",
    year: 2023,
    image: "https://i.kym-cdn.com/photos/images/newsfeed/001/499/826/2f0.png",
    github: "https://github.com/jinkim22/AlgoTrading",
    demo: "https://stocktradingbotdashboard.uw.r.appspot.com/"
  },
  {
    id: 3,
    title: "Camelyon16 Cancer Tumor Detection",
    description:
      "A deep learning model for detecting cancerous tumor cells. Built with Python and scikit-learn.",
    category: "Machine Learning",
    year: 2022,
    image: "https://www.frontiersin.org/files/Articles/476209/fmed-06-00310-HTML/image_m/fmed-06-00310-g001.jpg",
    github: "https://github.com/jinkim22/Camelyon17Challenge",
    demo: "https://www.youtube.com/watch?v=IFbzzf7vbBo"
  },
];
